export function vues(){
    const v = new Vue({
        el: '#site-header',
        data: {
            nav_flag: false,
            nav_acd_about: false,
            nav_acd_option: false,
        },
    });
}